import Alpine from 'alpinejs'

Alpine.data('multiCurrency', (currenciesPresent) => ({
    
    display: currenciesPresent[0],
    
    init() {
        Alpine.effect(() => {
            let preferredCurrencyCode = Alpine.store('currency').value
            if(!currenciesPresent.includes(preferredCurrencyCode)) {
                preferredCurrencyCode = 'EUR'
            }
            if(!currenciesPresent.includes(preferredCurrencyCode)) {
                preferredCurrencyCode = currenciesPresent[0]
            }
            this.display = preferredCurrencyCode
        })
    }
    
}))